import {
  SecureBusinessServiceProfile,
  Service,
  ServicesActivationCommand,
  SubscriberSafetyServiceProfile,
  UserMode,
} from "@sportal/api";

export const activationCommands: Record<string, ServicesActivationCommand> = {
  [UserMode.SBSingle]: [
    {
      service: Service.SecureBusiness,
      serviceProfile: SecureBusinessServiceProfile.Single,
    },
    {
      service: Service.SubscriberSafety,
      serviceProfile: SubscriberSafetyServiceProfile.SBSingle,
    },
  ],
  [UserMode.SBProfile]: [
    {
      service: Service.SecureBusiness,
      serviceProfile: SecureBusinessServiceProfile.Multiple,
    },
    {
      service: Service.SubscriberSafety,
      serviceProfile: SubscriberSafetyServiceProfile.SBMultiple,
    },
  ],
};
